// dependencies
import { useParams } from "react-router-dom";

// hooks
import { useCurrentUser } from "../../../../../api/hooks";

// utils
import isValidObjectID from "../../../../../utils/isValidObjectID";

type UseCompetenciesNavigationParamsReturn = {
	userId: string | undefined;
	employeeId: string | undefined;
	activePage: string;
	isLoading: boolean;
};

const useCompetenciesNavigationParams = (): UseCompetenciesNavigationParamsReturn => {
	const { data: me, isLoading } = useCurrentUser();

	const { employeeID, page } = useParams();

	const userId = me?.me?.authorization?.payload?.user_id;
	const employeeId = employeeID && isValidObjectID(employeeID) ? employeeID : userId;
	const activePage = page || "my";

	return {
		userId,
		employeeId,
		activePage,
		isLoading,
	};
};

export default useCompetenciesNavigationParams;
